import { Alert } from 'src/app/models/alert';
import type { AlertDetailDialogData } from 'src/app/service-center/alert-detail-dialog/alert-detail-dialog.component';
import { alertToSummary, linkedAlertData } from 'src/app/service-center/alert-detail-dialog/alert-link';

// The table's other rows for the same vehicle feed Other open alerts; the table is no stepping order.
export function alertsTableDialogData(alert: Alert, rows: Alert[]): AlertDetailDialogData {
  const vin = alert.vehicleState?.vin;
  const sameVehicle = rows.filter(r => r?.id && (r.id === alert.id || (vin && r.vehicleState?.vin === vin)));
  const startIndex = sameVehicle.findIndex(r => r.id === alert.id);
  return {
    ...linkedAlertData(alert),
    siblings: sameVehicle.length > 1 && startIndex >= 0
      ? { alerts: sameVehicle.map(alertToSummary), startIndex, stepping: false }
      : undefined,
  };
}
